<template>
  <AttrSelect
    label="字体"
    :value="shape.attrs.fontId"
    :disabled="!!attrDisabled"
    :options="familyOptions"
    @change="(val:string)=> shape.setAttrs({'fontId':val})"
  />
  <div v-if="uploadFont && props.shape.usingCustomFont" class="mt-2.5">
    <FontUpload :shape="shape" />
  </div>
  <AttrSelect
    v-if="!props.shape.usingCustomFont"
    class="mt-2.5"
    label="字重"
    :value="shape.attrs.fontWeight"
    :options="fontWeightOptions"
    :disabled="!!attrDisabled"
    @change="(val:any)=> shape.setAttrs({ 'fontWeight':val})"
  />
</template>
<script lang="ts" setup>
import { useTextFont } from '@/hooks';
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { PropType, computed, watch } from 'vue';
const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  uploadFont: {
    type: Boolean,
    default: false
  }
});

const { fontIdList, loadFontFile } = useTextFont();

const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const familyOptions = computed(() => {
  const res =
    fontIdList.value?.map((item) => {
      return {
        value: item.value,
        label: item.label
      };
    }) ?? [];
  if (props.uploadFont) {
    res.push({
      label: '自定义字体',
      value: 'custom' as 'misans'
    });
  }
  return res;
});

const fontWeightOptions = computed(
  () =>
    fontIdList.value?.find((i) => i.value === props.shape.attrs.fontId)
      ?.weights ?? []
);

watch(
  [() => props.shape.attrs.fontId, () => props.shape.attrs.fontWeight],
  () => {
    if (props.shape.attrs.fontId === 'custom') return;

    loadFontFile({
      remote: {
        fontId: props.shape.attrs.fontId ?? '',
        fontWeight: props.shape.attrs.fontWeight ?? '',
        fontFormat:
          fontIdList.value?.find((i) => i.value === props.shape.attrs.fontId)
            ?.format ?? 'otf'
      }
    });
  }
);
</script>

<style lang="less" scoped></style>
